import { Inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiServiceInterface } from '@hutsix/ngxh6';
import { environment } from '../../../environments/environment';

export interface AssistantChatMessage {
    role: 'user' | 'assistant';
    content: string;
}

export interface AssistantCitation {
    nbr: string;
    id: string;
}

export interface AssistantToolCall {
    tool: string;
    error: boolean;
}

export interface AssistantChatResponse {
    answer: string;
    citations?: AssistantCitation[];
    toolCalls?: AssistantToolCall[];
    usage?: any;
}

@Injectable({ providedIn: 'root' })
export class AssistantService {
    private readonly enabled: boolean;

    constructor(@Inject('ApiService') private api: ApiServiceInterface) {
        const assistantConfig = (environment as any).support?.assistant;
        this.enabled = assistantConfig?.enabled === true;
    }

    get isEnabled(): boolean {
        return this.enabled;
    }

    sendMessage(question: string, history: AssistantChatMessage[]): Observable<AssistantChatResponse> {
        return this.api
            .post({
                url: '/api/chat/message',
                data: { question, history },
                displayErrors: false,
            })
            .pipe(map((res: any) => res.data ?? res));
    }
}
